import * as React from "react";

import { ListGroup } from "react-bootstrap";
import { Link } from "react-router";
import { connect } from "shared/src/stores/storeConnect";
import MENU_STATE from "./MenuState";
import { MenuItem } from "../../../datatypes/MenuItem";
import { RefluxAction } from "reflux";
import MobileNavigationActions from "../../../actions/MobileNavigationActions";
import { isEmpty } from "shared/src/utils/util";

type Props = {
    items: Array<MenuItem>;
    currentPath: Array<string>;
    headerId: string;
    OpenSubTree: RefluxAction<[Array<string>, boolean]>;
    ChangeState: RefluxAction<[string, boolean]>;
    CloseMobileMenu: RefluxAction<[]>;
};

class MobileBrowsing extends React.Component<Props> {
    makeCorrectLink(child: MenuItem, text: string, key?: number) {
        if (child.relativeURL) {
            return (
                <Link
                    className="list-group-item"
                    to={child.relativeURL}
                    key={String(key ?? "") + child.id}
                    onClick={() => this.props.CloseMobileMenu.trigger()}>
                    {text}
                </Link>
            );
        } else if (child.absoluteURL) {
            return (
                <a
                    className="list-group-item"
                    href={child.absoluteURL}
                    key={String(key ?? "") + child.id}
                    onClick={() => this.props.CloseMobileMenu.trigger()}>
                    {text}
                </a>
            );
        }
        return null;
    }

    getRenderedChild(key: number, child: MenuItem) {
        //if in end of tree: show all articles from normal /category desktop view:
        const isLeaf = isEmpty(child.children);
        if (isLeaf) {
            return this.makeCorrectLink(child, child.name, key);
        } else {
            return (
                <a
                    className="list-group-item list-group-item-branch"
                    key={String(key) + child.id}
                    onClick={() => this.props.OpenSubTree.trigger([...this.props.currentPath, child.id], true)}>
                    {child.name}
                </a>
            );
        }
    }

    getSubTree(children: MenuItem[], pathNodes: string[]): MenuItem | undefined {
        //get the first id into the path
        const nodeId = pathNodes?.[0];
        //get the child node which matches the current id
        const child = children?.find((childInternal) => {
            return childInternal.id === nodeId;
        });
        if (pathNodes.length <= 1 || !child) {
            //We found it \o/ or not...
            return child;
        } else {
            //search further in subtree
            return this.getSubTree(child.children, pathNodes.slice(1));
        }
    }

    //the back button on top
    navigateBack(currentPath: string[]) {
        if (currentPath.length === 0) {
            this.props.ChangeState.trigger(MENU_STATE.START, false);
        } else {
            const parentCategoryPath = currentPath?.slice(0, -1);
            this.props.OpenSubTree.trigger(parentCategoryPath, false);
        }
    }

    //links for subcategory buttons
    renderChildren(children: MenuItem[]) {
        return (children ?? []).map((child, index: number) => {
            return this.getRenderedChild(index, child);
        });
    }

    getPathAndSubTree(currentPath: string[], items: MenuItem[]) {
        const subTree = this.getSubTree(items, currentPath);
        let returnPath;
        let returnSubTree;
        //is found node leaf: return parent node, else return node
        if (subTree && isEmpty(subTree.children)) {
            returnPath = currentPath?.slice(0, -1);
            returnSubTree = this.getSubTree(items, returnPath);
        } else {
            returnPath = currentPath;
            returnSubTree = subTree;
        }
        return { path: returnPath, subTree: returnSubTree };
    }

    render() {
        const items = this.props.items;
        if (items) {
            const currentPath = this.props.currentPath;
            const { path, subTree } = this.getPathAndSubTree(currentPath, items);
            //either subcategory name or "assortment" if on top level
            const menuTitle = subTree && subTree.name ? subTree.name : this.props.headerId;
            const children = subTree ? subTree.children : items;
            if (children) {
                return (
                    <ListGroup>
                        <a
                            className="list-group-item list-group-item-header list-group-item-back"
                            onClick={() => this.navigateBack(path)}>
                            <h1>{menuTitle}</h1>
                        </a>
                        {subTree && subTree.currentNodeLabel && this.makeCorrectLink(subTree, subTree.currentNodeLabel)}
                        {this.renderChildren(children)}
                    </ListGroup>
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    }
}

export default connect(
    {
        actions: [[MobileNavigationActions, ["OpenSubTree", "ChangeState", "CloseMobileMenu"]]]
    },
    MobileBrowsing
);
